/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://gis.clark.wa.gov/portal/jsapi/jsapi4/esri/copyright.txt for details.
*/
import{ManagedFBOAttachment as t}from"./ManagedFBOAttachment.js";import{AttachmentType as e}from"./ManagedFBObject.js";class s extends t{constructor(t,s,a){super(t,s,a),this.attachment=s,this.type=e.COLOR}}export{s as ManagedColorAttachment};
